import script from "./StoryPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./StoryPopup.vue?vue&type=script&setup=true&lang=ts"

import "./StoryPopup.vue?vue&type=style&index=0&id=970a66dc&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-970a66dc"]])

export default __exports__